/**
 * REGRAS DE NEGÓCIO QUE SÃO APLICADAS NO FRONTEND E BACKEND.
 */
import moment from 'moment';
import _ from 'lodash';
import { FiltroConstants } from '..';
import { normalizeFiltrosUI } from '../common/FiltroUtil';
import DatasetDruid from '../transform/DatasetDruid';
import Permissao from './Permissao';
import Rbac from './Rbac';
moment.updateLocale(moment.locale(), { invalidDate: '' });
export var TipoTabela;
(function (TipoTabela) {
    TipoTabela["TABELA_DINAMICA"] = "pivottable";
    TipoTabela["TABELA_NORMAL"] = "Tabela Normal";
})(TipoTabela || (TipoTabela = {}));
const formatTimestampDruid = (value) => {
    if (value)
        return moment(value).format('DD/MM/YY - HH:mm:ss');
    return null;
};
const formatDateDruid = (value) => {
    if (value)
        return moment(value).format('DD/MM/YY');
    return null;
};
/**
 * Aplicados apenas ao Frontend.
 */
const formatProtocoloOnlyFrontend = () => {
    let host = 'meus-exames.telemedicina.ufsc.br'; // para ambiente dev.
    const hostSplit = window.location.host.split('.');
    if (hostSplit.length > 1 && window.location.protocol.includes('https')) {
        host = `meus-exames.${hostSplit.slice(1).join('.')}`;
    }
    return (value) => {
        return `<a href="https://${host}/protocolo/${value}" target="_blank">${value}</a>`;
    };
};
const formatProtocolo = () => {
    if (typeof window !== 'undefined') {
        return formatProtocoloOnlyFrontend();
    }
    return (value) => value;
};
const defaultRulesCube = {
    permitirPeriodicidadeAgendamento: true,
    permissao: undefined,
    swapAtributos: undefined,
    limitLenFiltrosAdicionados: undefined,
    sempreAgrupado: false,
    propsUI: {
        disabledPrefixGrupo: false,
        atributosEstaticos: undefined,
        pivotState: undefined,
    },
    propsFiltroMap: undefined,
    transformations: [],
    filtrosDefault: [],
};
const rules = {
    cubo_pontos: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_PONTOS, swapAtributos: {
            __time: 'eq_data_inclusao_fmt',
        }, propsUI: {
            disabledPrefixGrupo: true,
        }, limitLenFiltrosAdicionados: 1, filtrosDefault: [
            {
                key: '1',
                atributo: 'eq_situacao',
                tipoComponente: FiltroConstants.TIPO_FILTRO.IN_SELECT,
                valor: 'Ativo',
            },
        ] }),
    cubo_pacs: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_PACS, limitLenFiltrosAdicionados: 1, transformations: [
            {
                attributes: ['__time'],
                transformation: formatDateDruid,
            },
        ], filtrosDefault: [
            {
                key: new Date().getTime(),
                atributo: '__time',
                atributosPermitidos: ['__time'],
                tipoComponente: FiltroConstants.TIPO_FILTRO.BETWEEN_INCLUSIVE_TIMESTAMP_MS,
                valor: () => {
                    const end = moment().toDate();
                    const start = moment().subtract(1, 'week').toDate();
                    return [start, end];
                },
            },
        ] }),
    cubo_telediagnostico: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_TELEDIAGNOSTICO, swapAtributos: {
            __time: 'data_exame_fmt',
            data_laudo: 'data_laudo_fmt',
        }, limitLenFiltrosAdicionados: 3, propsUI: {
            disabledPrefixGrupo: true,
        }, filtrosDefault: [
            {
                key: new Date().getTime(),
                atributo: '__time',
                atributosPermitidos: ['__time', 'data_laudo'],
                tipoComponente: FiltroConstants.TIPO_FILTRO.BETWEEN_INCLUSIVE_TIMESTAMP_MS,
                valor: () => {
                    const end = moment().toDate();
                    const start = moment().subtract(1, 'week').toDate();
                    return [start, end];
                },
            },
            {
                key: new Date().getTime() + 1,
                atributo: 'exame_valido',
                disabled: true,
                tipoComponente: FiltroConstants.TIPO_FILTRO.IN_SELECT,
                valor: 'Sim',
            },
            {
                key: new Date().getTime() + 2,
                atributo: 'exame_modalidade',
                disabled: true,
                tipoComponente: FiltroConstants.TIPO_FILTRO.IN_SELECT,
                valor: '',
            },
        ] }),
    cubo_exame_eletroencefalo: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_EEG }),
    cubo_exame_dermato: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_DERMATO, swapAtributos: {
            data_solicitacao_exame: 'data_solicitacao_exame_fmt',
            data_exame: 'data_exame_fmt',
            data_laudo: 'data_laudo_fmt',
        }, transformations: [
            {
                attributes: ['protocolo'],
                transformation: formatProtocolo(),
            },
            {
                attributes: ['data_exame_invalido'],
                transformation: formatTimestampDruid,
            },
        ], filtrosDefault: [
            {
                key: new Date().getTime(),
                atributo: 'data_laudo',
                tipoComponente: FiltroConstants.TIPO_FILTRO.BETWEEN_INCLUSIVE_TIMESTAMP_MS,
                valor: () => {
                    const end = moment().toDate();
                    const start = moment().subtract(1, 'week').toDate();
                    return [start, end];
                },
            },
            {
                key: new Date().getTime() + 1,
                atributo: 'valido',
                disabled: true,
                tipoComponente: FiltroConstants.TIPO_FILTRO.IN_SELECT,
                valor: 'Sim',
            },
        ] }),
    cubo_exame_estomato: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_ESTOMATO, filtrosDefault: [
            {
                key: new Date().getTime(),
                atributo: 'data_exame',
                tipoComponente: FiltroConstants.TIPO_FILTRO.BETWEEN_INCLUSIVE_TIMESTAMP_MS,
                valor: () => {
                    const end = moment().toDate();
                    const start = moment().subtract(1, 'week').toDate();
                    return [start, end];
                },
            },
            {
                key: new Date().getTime() + 1,
                atributo: 'valido',
                disabled: true,
                tipoComponente: FiltroConstants.TIPO_FILTRO.IN_SELECT,
                valor: 'Sim',
            },
        ] }),
    cubo_exame_eletro: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_ECG, propsFiltroMap: {
            valido: {
                autocomplete: ['Sim', 'Não'],
            },
        }, transformations: [
            {
                attributes: ['data_solicitacao'],
                transformation: formatTimestampDruid,
            },
            {
                attributes: ['data_exame'],
                transformation: formatTimestampDruid,
            },
            {
                attributes: ['data_laudo'],
                transformation: formatTimestampDruid,
            },
            {
                attributes: ['protocolo'],
                transformation: formatProtocolo(),
            },
        ], filtrosDefault: [
            {
                key: new Date().getTime(),
                atributo: 'data_laudo',
                tipoComponente: FiltroConstants.TIPO_FILTRO.BETWEEN_INCLUSIVE_TIMESTAMP_MS,
                valor: () => {
                    const end = moment().toDate();
                    const start = moment().subtract(1, 'week').toDate();
                    return [start, end];
                },
            },
        ] }),
    cubo_tfd: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_TFD, filtrosDefault: [] }),
    cubo_tfd_passagens: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_TFD_PASSAGENS }),
    cubo_funcionario_atividades: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_FUNCIONARIO_ATIVIDADES, limitLenFiltrosAdicionados: 2, filtrosDefault: [
            {
                key: new Date().getTime(),
                atributo: 'data_acao',
                tipoComponente: FiltroConstants.TIPO_FILTRO.BETWEEN_INCLUSIVE_TIMESTAMP_MS,
                valor: () => {
                    const end = moment().toDate();
                    const start = moment().subtract(1, 'week').toDate();
                    return [start, end];
                },
            },
            {
                key: 2,
                atributo: 'tipo',
                disabled: true,
                tipoComponente: FiltroConstants.TIPO_FILTRO.IN_SELECT,
                valor: '',
            },
        ], transformations: [
            {
                attributes: ['data_acao'],
                transformation: formatTimestampDruid,
            },
        ] }),
    cubo_funcionario_alunosativos: Object.assign(Object.assign({}, defaultRulesCube), { sempreAgrupado: true, permitirPeriodicidadeAgendamento: false, permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_FUNCIONARIO_ALUNOS_ATIVOS, propsUI: {
            atributosEstaticos: ['medida_contador'],
            pivotState: {
                aggregatorList: [
                    {
                        vals: ['Medidas: Quantidade'],
                        aggTitle: 'Quantidade',
                        aggregatorName: 'Integer Sum',
                    },
                ],
            },
        }, transformations: [], filtrosDefault: [] }),
    cubo_funcionario: Object.assign(Object.assign({}, defaultRulesCube), { permitirPeriodicidadeAgendamento: false, permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_FUNCIONARIO, propsUI: {
            disabledPrefixGrupo: true,
        }, transformations: [], filtrosDefault: [] }),
    cubo_dashboard_teleconsultoria_atrasadas: Object.assign(Object.assign({}, defaultRulesCube), { permitirPeriodicidadeAgendamento: false, permissao: [
            Permissao.ANALISE_ACESSAR_DASHBOARD_TELECONSULTORIA_ESTADUAL,
            Permissao.ANALISE_ACESSAR_DASHBOARD_TELECONSULTORIA_MUNICIPAL,
            Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_TELECONSULTORIAS_EM_ABERTO,
        ], limitLenFiltrosAdicionados: 3, propsUI: {
            atributosEstaticos: ['medida_contador'],
            pivotState: {
                aggregatorList: [
                    {
                        vals: ['Medidas: Quantidade de teleconsultorias'],
                        aggTitle: 'Soma das teleconsultorias',
                        aggregatorName: 'Integer Sum',
                    },
                ],
            },
        }, transformations: [], filtrosDefault: [
            {
                key: 2,
                disabled: true,
                habilitarRegraVinculo: true,
                atributo: 'rede_teleconsultoria',
                rotulo: 'Rede teleconsultoria',
                tipoComponente: 'IN_SELECT',
                valor: '',
            },
            {
                key: 3,
                disabled: true,
                habilitarRegraVinculo: true,
                atributo: 'estado',
                rotulo: 'Estado',
                tipoComponente: 'IN_SELECT',
                valor: '',
            },
            {
                key: 4,
                disabled: true,
                habilitarRegraVinculo: true,
                atributo: 'cidade',
                rotulo: 'Município',
                dependsOn: ['estado'],
                tipoComponente: 'IN_SELECT',
                valor: '',
            },
        ] }),
    cubo_teleconsultoria: Object.assign(Object.assign({}, defaultRulesCube), { permissao: Permissao.ANALISE_ACESSAR_TABELA_DADOS_CUBO_TELECONSULTORIAS, propsFiltroMap: {
            situacao_tele: {
                autocomplete: [
                    'Invalidada',
                    'Rascunho',
                    'Encaminhada para telerregulação / Aguardando resposta',
                    'Devolvida',
                    'Encaminhada para o(a) teleconsultor(a) / Aguardando resposta',
                    'Aguardando resposta complementar',
                    'Resposta sendo finalizada',
                    'Resposta em edição',
                    'Respondida',
                    'Aguardando tréplica / Aguardando resposta',
                    'Tréplica respondida',
                    'Avaliada',
                ],
            },
        }, transformations: [
            {
                attributes: ['data_teleconsultoria'],
                transformation: formatTimestampDruid,
            },
            {
                attributes: ['data_solicitacao'],
                transformation: formatTimestampDruid,
            },
            {
                attributes: ['data_atendimento'],
                transformation: formatTimestampDruid,
            },
            {
                attributes: ['data_leitura'],
                transformation: formatTimestampDruid,
            },
            {
                attributes: ['data_avaliacao'],
                transformation: formatTimestampDruid,
            },
        ], filtrosDefault: [
            {
                key: new Date().getTime(),
                atributo: 'data_solicitacao',
                // disabled: true,
                tipoComponente: FiltroConstants.TIPO_FILTRO.BETWEEN_INCLUSIVE_TIMESTAMP_MS,
                valor: () => {
                    const end = moment().toDate();
                    const start = moment().subtract(1, 'month').toDate();
                    return [start, end];
                },
            },
        ] }),
};
const getRules = (cubeName) => {
    if (!cubeName)
        return null;
    return rules[cubeName] || defaultRulesCube;
};
export const getDefaultFiltros = (cubeName) => {
    var _a;
    let filtros = normalizeFiltrosUI(((_a = getRules(cubeName)) === null || _a === void 0 ? void 0 : _a.filtrosDefault) || []);
    return filtros;
};
export const permitePeriodicidade = (cubeName) => {
    var _a;
    return !!((_a = getRules(cubeName)) === null || _a === void 0 ? void 0 : _a.permitirPeriodicidadeAgendamento);
};
export const getPropsFiltroMap = (cubeName) => {
    var _a;
    return ((_a = getRules(cubeName)) === null || _a === void 0 ? void 0 : _a.propsFiltroMap) || {};
};
/**
 * Filtra os cubos de acordo com sua permissão de acesso.
 *
 * @param cubos Todos os cubos para tabela de dados
 * @returns apenas cubos permitidos
 */
export const filtrarCubosPermitidos = (cubos = [], permissoesRBAC) => {
    const rbac = new Rbac(permissoesRBAC, undefined);
    return cubos.filter((cubo) => {
        var _a;
        const permissao = (_a = getRules(cubo.dataset)) === null || _a === void 0 ? void 0 : _a.permissao;
        // Nem todos os cubos possuem permissão registrada.
        if (permissao) {
            return rbac.permitir(permissao);
        }
        // Os demais cubos ficam desabilitados. Ou seja, obrigatório que tenha permissão.
        return false;
    });
};
export const naoExisteFiltros = (filtros = []) => {
    return !(filtros.length > 0);
};
/**
 * Regras principais para executar o filtro.
 */
export const validarExecutarConsulta = (cubo) => {
    const rule = getRules(cubo);
    if (!rule)
        return false;
    // Se precisa de filtro obrigatório, validar que todos os campos precisam estar preenchidos.
    return cubo;
};
/**
 * Recuperar configurações da tela de acordo com o cubo selecionado.
 */
export const getPropsUI = (cubeName) => {
    var _a;
    return (_a = getRules(cubeName)) === null || _a === void 0 ? void 0 : _a.propsUI;
};
export const validarLimiteDataset = (data) => {
    const LIMIT = 10000;
    const count = data.length - 1;
    const valid = count <= LIMIT;
    return [valid, count];
};
/**
 * Aplicação de transformações para frontend ou exportação via API.
 * Regra de negócio aplicado a saida de dados.
 */
export const formatDataset = (cubeName, dataset) => {
    var _a;
    // Inverter Header, possiveis swap de atributos
    dataset[0] = invertAtributos(cubeName, dataset[0]);
    const builder = new DatasetDruid(dataset);
    const transformationsFn = ((_a = getRules(cubeName)) === null || _a === void 0 ? void 0 : _a.transformations) || [];
    return builder.applyTransformations(transformationsFn).build();
};
/**
 * Adiciona algumas regras nos atributos antes de ir para o Servidor.
 *
 * @param cubo nome do dataset no Apache Druid.
 * @param dimensoes colunas do dataset no Apache Druid.
 * @returns
 */
export const normalizeAtributos = (cubo, dimensoes = []) => {
    // RN01: Regra para trocar o atributo selecionado por outro atributo
    // @TODO Adicionar no metadados a divisão entre Atributo e Filtro.
    const swapAtributos = getRules(cubo).swapAtributos;
    if (!swapAtributos)
        return dimensoes;
    return dimensoes.map((attr) => swapAtributos[attr] || attr);
};
export const normalizeDimensoesAndMedidas = (cubo, atributosSelecionados = [], metaAtributos, agrupado = false) => {
    const atributosDoTipoMedida = metaAtributos.filter((meta) => meta.grupo === 'Medidas').map((meta) => meta.atributo);
    let medidas, dimensoes;
    if (agrupado) {
        medidas = _.intersection(atributosSelecionados, atributosDoTipoMedida) || [];
        dimensoes = _.difference(atributosSelecionados, atributosDoTipoMedida) || [];
    }
    else {
        dimensoes = atributosSelecionados || [];
        medidas = [];
    }
    const nDimensoes = normalizeAtributos(cubo, dimensoes);
    return [nDimensoes, medidas];
};
export const isSempreAgrupado = (cubo) => {
    var _a;
    return ((_a = getRules(cubo)) === null || _a === void 0 ? void 0 : _a.sempreAgrupado) || false;
};
/**
 * Inverte as regras adicionadas pela função normalizeAtributos, executa na resposta vinda do servidor.
 *
 * @param cubeName nome do dataset no Apache Druid.
 * @param atributosSelecionados colunas do dataset no Apache Druid.
 * @returns
 */
export const invertAtributos = (cubeName, atributosSelecionados = []) => {
    const swapAtributos = getRules(cubeName).swapAtributos;
    if (!swapAtributos)
        return atributosSelecionados;
    const invertAtributos = _.invert(swapAtributos);
    return atributosSelecionados.map((attr) => invertAtributos[attr] || attr);
};
/**
 * Renomear cabeçalho de um dataset.
 */
export const renameHeaders = (headers, metaAtributos, disabledPrefixGrupo = false) => {
    let template = (metaAtributoEncontrado) => `${metaAtributoEncontrado.grupo}: ${metaAtributoEncontrado.rotulo}`;
    if (disabledPrefixGrupo) {
        template = (metaAtributoEncontrado) => metaAtributoEncontrado.rotulo;
    }
    const newHeaders = headers.map((columname) => {
        const metaAtributoEncontrado = metaAtributos.filter((metaAtributo) => metaAtributo.atributo == columname)[0];
        return metaAtributoEncontrado ? template(metaAtributoEncontrado) : columname;
    });
    return newHeaders;
};
export const renameHeadersByCubo = (cubeName, headers, metaAtributos) => {
    var _a;
    const disabledPrefixGrupo = ((_a = getPropsUI(cubeName)) === null || _a === void 0 ? void 0 : _a.disabledPrefixGrupo) || false;
    return renameHeaders(headers, metaAtributos, disabledPrefixGrupo);
};
export const disabledFilter = (cubeName, filtrosAdicionados) => {
    var _a;
    if (!cubeName || cubeName === '')
        return true;
    const limitLenFiltrosAdicionados = ((_a = getRules(cubeName)) === null || _a === void 0 ? void 0 : _a.limitLenFiltrosAdicionados) || -1;
    if (filtrosAdicionados && filtrosAdicionados.length === limitLenFiltrosAdicionados)
        return true;
    return false;
};
